import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { useScrollToTop } from "@sparefoot/react-commons/hooks";
import { Text } from "components/core/Typography";
import { Button } from "components/core/Button";

import "./ScrollToTop.scss";

function ScrollToTop({ className }) {
	const [handleClick, isVisible] = useScrollToTop();
	return (
		<Button
			className={classnames("sf-scroll-to-top", className, {
				visible: isVisible
			})}
			onClick={handleClick}
			fullWidth={false}
		>
			<Text
				color="blue"
				weight="bold"
				last
			>
				Scroll to Top
			</Text>
		</Button>
	);
}

ScrollToTop.propTypes = {
	className: PropTypes.string
};

export default ScrollToTop;
